/* @flow */
import * as React from 'react';
import { Flex } from '@locus-taxy/neo-ui';
import { type ThemeType } from 'react-css-themr';
import classnames from 'classnames';
import { Icon } from 'common/components/core/icon';
import { PopoverTriggerEnum } from 'common/components/core/popover/popOverFactory';
import { DivWithPopover } from 'common/components/core/wrappers/Div';

type Props = {
    theme: ThemeType,
    className?: ?string,
    isSelected: boolean,
    hasLimitation: boolean,
    limitationText: React.Node,
    source: {
        id: string,
        title: string,
        icon?: React.Node
    },
    onClick?: (id: string) => void
};

export default class DefaultSubSection extends React.PureComponent<Props> {
    handleClick = () => {
        const {
            source: { id },
            onClick
        } = this.props;
        onClick && onClick(id);
    };

    render() {
        const {
            theme,
            className,
            isSelected,
            hasLimitation,
            limitationText,
            source
        } = this.props;
        const { id, title, icon } = source;
        const testId = id.replace(' ', '');
        return (
            <DivWithPopover
                testid={`${testId}SideBar`}
                theme={theme}
                className={classnames(theme.item, {
                    [theme.selectedItem]: isSelected,
                    [theme.hasLimitation]: hasLimitation,
                    [className]: !!className
                })}
                onClick={this.handleClick}
                popOverClassName={theme.infoPopover}
                popOverContent={hasLimitation ? limitationText : null}
                preferPlace={'right'}
                disableAnimation
                triggerPopoverOn={PopoverTriggerEnum.Hover}
            >
                {title}
                {icon && (
                    <Flex marginLeft="auto" alignItems="center">
                        {icon}
                    </Flex>
                )}
                {hasLimitation ? (
                    <Icon
                        solid
                        circular
                        icon="info"
                        theme={theme}
                        className={theme.limitationIcon}
                    />
                ) : null}
            </DivWithPopover>
        );
    }
}
